// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import $ from 'jquery';
import './plUpload/fg.upload';

class FGUpload extends WebComponent {
  didMount() {
    const {
      runtimes,
      autoStart,
      dragdrop,
      disappearUploadedFiles,
      disappearErrors,
      fileDataId,
      fileDataName,
      formUrl,
      url,
      urlToRemove,
      dropElement,
      filters,
      maxFileSize,
      maxFileCount,
      maxFileQueueCount,
      statusDiv,
      progressTarget,
      progressWidth,
      browseButton,
      startQueueTarget,
      cancelQueueTarget,
      removeButton,
      labelInQueue,
      labelUploading,
      labelComplete,
      labelStopped,
      labelCancelled,
      labelFileQueued,
      labelUploadCompleted,
      labelQueueCompleted,
      labelErrorUploadLimit,
      labelErrorQueueLimit,
      labelErrorFileTooBig,
      labelErrorZeroLength,
      labelErrorInvalidFileType,
      labelErrorUnknownError,
      labelErrorUploadError,
    } = this.props;

    $(this.element).fgUpload({
      runtimes: runtimes,
      dragdrop: dragdrop,
      file_data_id: fileDataId,
      file_data_name: fileDataName,
      formUrl: formUrl,
      url: url,
      urlToRemove: urlToRemove,
      drop_element: dropElement,
      filters: filters,
      max_file_size: parseInt(maxFileSize),
      max_file_count: parseInt(maxFileCount),
      max_file_queue_count: parseInt(maxFileQueueCount),
      statusDiv: statusDiv,
      progressTarget: progressTarget,
      progressWidth: progressWidth,
      browse_button: browseButton,
      startQueueTarget: startQueueTarget,
      cancelQueueTarget: cancelQueueTarget,
      remove_button: removeButton,
      labelInQueue: labelInQueue,
      labelUploading: labelUploading,
      labelComplete: labelComplete,
      labelStopped: labelStopped,
      labelCancelled: labelCancelled,
      labelFileQueued: labelFileQueued,
      labelUploadCompleted: labelUploadCompleted,
      labelQueueCompleted: labelQueueCompleted,
      labelErrorUploadLimit: labelErrorUploadLimit,
      labelErrorQueueLimit: labelErrorQueueLimit,
      labelErrorFileTooBig: labelErrorFileTooBig,
      labelErrorZeroLength: labelErrorZeroLength,
      labelErrorInvalidFileType: labelErrorInvalidFileType,
      labelErrorUnknownError: labelErrorUnknownError,
      labelErrorUploadError: labelErrorUploadError,
      disappearUploadedFiles: disappearUploadedFiles,
      disappearErrors: disappearErrors,
    });
  }
}


FGUpload.defaultProps = {
  runtimes: "html5,html4",
  autoStart: false,
  dragdrop: true,
  disappearUploadedFiles: 0, // default 10000 - time in ms, 0 for no disappear
  disappearErrors: 0, // default 5000
}

export default FGUpload;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FGUpload.js